module.exports = __webpack_public_path__ + "static/media/FileArrowDown.063e49fa.svg";